import { render, staticRenderFns } from "./PaySlipPage.vue?vue&type=template&id=4c6e6abd&scoped=true&"
import script from "./PaySlipPage.vue?vue&type=script&lang=js&"
export * from "./PaySlipPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e6abd",
  null
  
)

export default component.exports